module.exports = __webpack_public_path__ + "c3b640fe8089ba4cc53242a5f4db93f9.svg";